import React from "react";
import { Divider } from "@mantine/core";
import TransactionFilters from "./components/TransactionFilters";
import TransactionContent from "./components/TransactionContent";

const TransactionsPageContent = React.memo(
  ({
    filters,
    data,
    paginationProps,
    merchants,
    exportProps,
    modals,
    isSuperAdmin,
  }) => {
    return (
      <div className="flex flex-col min-h-full">
        <div className="flex-shrink-0">
          <Divider my="sm" />
          <TransactionFilters
            filters={filters}
            merchants={merchants}
            exportProps={exportProps}
            isSuperAdmin={isSuperAdmin}
          />
        </div>

        <div className="flex-1">
          <TransactionContent
            data={data}
            paginationProps={paginationProps}
            filters={filters}
            merchants={merchants}
            modals={modals}
            isSuperAdmin={isSuperAdmin}
          />
        </div>
      </div>
    );
  },
);

export default TransactionsPageContent;
